import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Button, Dropdown } from 'semantic-ui-react';
import { FiSettings } from 'react-icons/fi';
import MediaQuery from 'react-responsive';

import { setTimesheetGroupBy } from 'services/ui/actions';
import { selectTimesheetGroupBy } from 'services/ui/selectors';

const options = [
    {
        text: 'date',
        value: 'date'
    },
    {
        text: 'person',
        value: 'person.fullName'
    },
    {
        text: 'area',
        value: 'entity.pathNames'
    }
];

interface StateProps {
    groupBy?: string;
}

interface DispatchProps {
    setTimesheetGroupBy: Function;
}

type Props = StateProps & DispatchProps;

export class TimesheetGroupByDropdown extends React.PureComponent<Props> {
    handleChange = (value: string): void => {
        const { groupBy } = this.props;

        this.props.setTimesheetGroupBy(value === groupBy ? undefined : value);
    };

    render(): React.ReactElement {
        const { groupBy } = this.props;

        return (
            <MediaQuery minWidth={1025}>
                {(matches: boolean): React.ReactElement => (
                    <Dropdown
                        icon={null}
                        floating
                        direction="left"
                        trigger={
                            <Button
                                circular
                                icon
                                style={{
                                    color: matches ? undefined : '#fff',
                                    padding: 0,
                                    background: 'transparent',
                                    boxShadow: 'none',
                                    marginLeft: 5
                                }}
                            >
                                <FiSettings
                                    size="24"
                                    style={{ verticalAlign: 'middle' }}
                                />
                            </Button>
                        }
                    >
                        <Dropdown.Menu>
                            <Dropdown.Header content="Group by" />
                            {options.map(({ value, text }) => (
                                <Dropdown.Item
                                    key={value}
                                    onClick={(): void =>
                                        this.handleChange(value)
                                    }
                                    active={value === groupBy}
                                    selected={value === groupBy}
                                >
                                    {text}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                )}
            </MediaQuery>
        );
    }
}

const mapStateToProps = createStructuredSelector<any, any, any>({
    groupBy: selectTimesheetGroupBy
});

export default connect(mapStateToProps, { setTimesheetGroupBy })(
    TimesheetGroupByDropdown
);
